module.exports = __webpack_public_path__ + "static/img/Cameron-Murray.4e55939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cameron-Murray.jpg
// module id = 2C4e
// module chunks = 0